import { Link } from 'gatsby';
import React from 'react';
import { getURLPathname } from '../../../../../utils/parseURL';
import { FurnitureBottomHeaderListItem, FurnitureTopHeaderListItem } from '../../../../lists/items/header';

export const FurnitureContentDropdown = ({ activeMenuContent }) => {
  if (!activeMenuContent) {
    return null;
  }

  const topCount = activeMenuContent?.contentLink?.expanded?.itemsPerRowTop || 1;
  const bottomCount = activeMenuContent.contentLink.expanded?.itemsPerRowBottom || 3;

  return (
    <div className="primary-navigation__list">
      <ul
        className={`primary-navigation__list--count-${topCount}`}
        data-items-id={activeMenuContent?.contentLink?.expanded?.id || null}
      >
        {activeMenuContent.contentLink.expanded.subMenusTop
          ?.filter(
            (item2) =>
              item2 && Object.prototype.toString.call(item2) === '[object Object]' && Object.keys(item2)?.length > 0
          )
          .map((item2, index2) => (
            <FurnitureTopHeaderListItem
              key={item2?.contentLink?.expanded?.id || index2}
              item={item2?.contentLink?.expanded || null}
              count={topCount}
            />
          ))}
      </ul>

      <ul
        className={`primary-navigation__list--count-${bottomCount}`}
        data-items-id={activeMenuContent?.contentLink?.expanded?.id || null}
      >
        {activeMenuContent.contentLink.expanded.subMenusBottom
          ?.filter(
            (item2) =>
              item2 && Object.prototype.toString.call(item2) === '[object Object]' && Object.keys(item2)?.length > 0
          )
          .map((item2, index2) => (
            <FurnitureBottomHeaderListItem
              key={item2?.contentLink?.expanded?.id || index2}
              item={item2?.contentLink?.expanded || null}
              count={bottomCount}
            />
          ))}
      </ul>

      <div className="primary-navigation__list-cta">
        <Link
          to={getURLPathname(activeMenuContent.contentLink.expanded.showAllLinkBottom.url || '#')}
          className="btn btn--primary btn--small"
        >
          <span>{activeMenuContent.contentLink.expanded.showAllLinkBottom.text || ''}</span>
        </Link>
      </div>
    </div>
  );
};
